export default __webpack_public_path__ + "static/media/mp_check_icon_gray.009cb603.svg";